// SPDX-FileCopyrightText: 2025 Sequent Tech Inc <legal@sequentech.io>
//
// SPDX-License-Identifier: AGPL-3.0-only
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
export var VotingPortalErrorType;
(function (VotingPortalErrorType) {
    VotingPortalErrorType["NO_ELECTION_EVENT"] = "NO_ELECTION_EVENT";
    VotingPortalErrorType["INTERNAL_ERROR"] = "INTERNAL_ERROR";
    VotingPortalErrorType["UNABLE_TO_FETCH_DATA"] = "UNABLE_TO_FETCH_DATA";
    VotingPortalErrorType["UNABLE_TO_ENCRYPT_BALLOT"] = "UNABLE_TO_ENCRYPT_BALLOT";
    VotingPortalErrorType["UNABLE_TO_CAST_BALLOT"] = "UNABLE_TO_CAST_BALLOT";
    VotingPortalErrorType["NO_BALLOT_STYLE"] = "NO_BALLOT_STYLE";
    VotingPortalErrorType["INCONSISTENT_HASH"] = "INCONSISTENT_HASH";
    VotingPortalErrorType["CERT_AUTH_FAILED"] = "CERT_AUTH_FAILED";
})(VotingPortalErrorType || (VotingPortalErrorType = {}));
export var ElectionScreenErrorType;
(function (ElectionScreenErrorType) {
    ElectionScreenErrorType["FETCH_DATA"] = "unableToFetchData";
    ElectionScreenErrorType["NO_AREA"] = "noVotingArea";
    ElectionScreenErrorType["NETWORK"] = "networkError";
    ElectionScreenErrorType["NO_ELECTION_EVENT"] = "noElectionEvent";
    ElectionScreenErrorType["OBTAINING_ELECTION"] = "obtainingElectionFromID";
    ElectionScreenErrorType["BALLOT_STYLES_EML"] = "ballotStylesEmlError";
})(ElectionScreenErrorType || (ElectionScreenErrorType = {}));
export var ElectionScreenMsgType;
(function (ElectionScreenMsgType) {
    ElectionScreenMsgType["NOT_PUBLISHED"] = "electionEventNotPublished";
    ElectionScreenMsgType["NO_ELECTIONS"] = "noElections";
})(ElectionScreenMsgType || (ElectionScreenMsgType = {}));
export var CastBallotsErrorType;
(function (CastBallotsErrorType) {
    CastBallotsErrorType["NETWORK_ERROR"] = "NETWORK_ERROR";
    CastBallotsErrorType["UNABLE_TO_FETCH_DATA"] = "UNABLE_TO_FETCH_DATA";
    CastBallotsErrorType["LOAD_ELECTION_EVENT"] = "LOAD_ELECTION_EVENT";
    CastBallotsErrorType["CAST_VOTE"] = "CAST_VOTE";
    CastBallotsErrorType["CAST_VOTE_TIMEOUT"] = "CAST_VOTE_timeout";
    CastBallotsErrorType["NO_BALLOT_SELECTION"] = "NO_BALLOT_SELECTION";
    CastBallotsErrorType["NO_BALLOT_STYLE"] = "NO_BALLOT_STYLE";
    CastBallotsErrorType["NO_AUDITABLE_BALLOT"] = "NO_AUDITABLE_BALLOT";
    CastBallotsErrorType["INCONSISTENT_HASH"] = "INCONSISTENT_HASH";
    CastBallotsErrorType["ELECTION_EVENT_NOT_OPEN"] = "ELECTION_EVENT_NOT_OPEN";
    CastBallotsErrorType["UNKNOWN_ERROR"] = "UNKNOWN_ERROR";
    CastBallotsErrorType["SESSION_STORAGE_ERROR"] = "SESSION_STORAGE_ERROR";
    CastBallotsErrorType["REAUTH_FAILED"] = "REAUTH_FAILED";
    CastBallotsErrorType["SESSION_EXPIRED"] = "SESSION_EXPIRED";
    CastBallotsErrorType["PARSE_BALLOT_DATA_ERROR"] = "PARSE_BALLOT_DATA_ERROR";
    CastBallotsErrorType["NOT_VALID_BALLOT_DATA_ERROR"] = "NOT_VALID_BALLOT_DATA_ERROR";
    CastBallotsErrorType["FETCH_DATA_TIMEOUT_ERROR"] = "FETCH_DATA_TIMEOUT_ERROR";
    CastBallotsErrorType["TO_HASHABLE_BALLOT_ERROR"] = "TO_HASHABLE_BALLOT_ERROR";
    CastBallotsErrorType["INTERNAL_ERROR"] = "INTERNAL_ERROR";
})(CastBallotsErrorType || (CastBallotsErrorType = {}));
export var WasmCastBallotsErrorType;
(function (WasmCastBallotsErrorType) {
    WasmCastBallotsErrorType["PARSE_ERROR"] = "PARSE_ERROR";
    WasmCastBallotsErrorType["DESERIALIZE_AUDITABLE_ERROR"] = "DESERIALIZE_AUDITABLE_ERROR";
    WasmCastBallotsErrorType["DESERIALIZE_HASHABLE_ERROR"] = "DESERIALIZE_HASHABLE_ERROR";
    WasmCastBallotsErrorType["CONVERT_ERROR"] = "CONVERT_ERROR";
    WasmCastBallotsErrorType["SERIALIZE_ERROR"] = "SERIALIZE_ERROR";
})(WasmCastBallotsErrorType || (WasmCastBallotsErrorType = {}));
var VotingPortalError = /** @class */ (function (_super) {
    __extends(VotingPortalError, _super);
    function VotingPortalError(type) {
        var _this = _super.call(this, type) || this;
        _this.name = "VotingPortalError";
        _this.type = type;
        return _this;
    }
    return VotingPortalError;
}(Error));
export { VotingPortalError };
